import type { LogLevel, LogMeta, SentryLike } from './types'

export function handleSentry(sentry: SentryLike | undefined, level: LogLevel, message: string, meta: LogMeta): void {
  if (!sentry || !meta.sentry) {
    return
  }

  // Build tags/extras from meta, excluding internal flags
  const { sentry: _s, index: _i, error, data: _data, ...rest } = meta
  const extras = Object.keys(rest).length > 0 ? rest : undefined

  // captureMessage's second argument is either a bare severity level or a CaptureContext
  // (which itself carries `level`) -- passing a literal level string like the branches below
  // used to do silently discards `extras`, since a plain string and `{ level, extra }` are
  // mutually exclusive shapes of the same param. Route through the context form whenever there
  // are extras to keep, so warn/info/debug captures stop losing the same fields error captures
  // already keep via captureException's second argument.
  if (level === 'error' && error) {
    sentry.captureException(error, extras ? { extra: extras } : undefined)
  } else if (level === 'error') {
    sentry.captureMessage(message, extras ? { level: 'error', extra: extras } : 'error')
  } else if (level === 'warn') {
    sentry.captureMessage(message, extras ? { level: 'warning', extra: extras } : 'warning')
  } else {
    sentry.captureMessage(message, extras ? { level, extra: extras } : level)
  }
}

export function addBreadcrumb(
  sentry: SentryLike | undefined,
  level: LogLevel,
  namespace: string,
  message: string,
  meta?: Record<string, unknown>
): void {
  if (!sentry) {
    return
  }

  sentry.addBreadcrumb({
    category: namespace,
    message,
    level,
    data: meta
  })
}
